/* KALUP - footer: show each link only once.
   The store's footer menu has "Refund Policy" twice; this hides repeats
   (same title + same link) in every footer column, in this theme only.
   The menu itself is not changed. */
(function () {
  function dedupe(root) {
    var lists = (root || document).querySelectorAll('.footer-block__details-content');
    Array.prototype.forEach.call(lists, function (list) {
      var seen = {};
      Array.prototype.slice.call(list.children).forEach(function (li) {
        var a = li.querySelector('a');
        if (!a) return;
        var key = (a.getAttribute('href') || '') + '|' + a.textContent.trim().toLowerCase();
        if (seen[key]) {
          li.remove();
        } else {
          seen[key] = true;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dedupe(); });
  } else {
    dedupe();
  }

  document.addEventListener('shopify:section:load', function (event) { dedupe(event.target); });
})();